import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/kontakt/page.tsx");
